import React from 'react';
import { useTranslation } from 'react-i18next';
import { getStoreUrl } from '../utils/storeUrls';

const FeaturesPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  
  const features = [
    {
      title: t('featuresPage.features.aiTranscription.title', 'AI-Powered Transcription'),
      description: t('featuresPage.features.aiTranscription.description', 'Convert any audio to text with industry-leading accuracy'),
      icon: '🎯'
    },
    {
      title: t('featuresPage.features.smartSummaries.title', 'Smart Summaries'),
      description: t('featuresPage.features.smartSummaries.description', 'Get instant AI-generated summaries of your recordings'),
      icon: '📝'
    },
    {
      title: t('featuresPage.features.multipleLanguages.title', 'Multiple Languages'),
      description: t('featuresPage.features.multipleLanguages.description', 'Support for 30+ languages and regional accents'),
      icon: '🌍'
    },
    {
      title: t('featuresPage.features.realTimeProcessing.title', 'Real-time Processing'),
      description: t('featuresPage.features.realTimeProcessing.description', 'See transcriptions appear as you speak'),
      icon: '⚡'
    },
    {
      title: t('featuresPage.features.customVocabulary.title', 'Custom Vocabulary'),
      description: t('featuresPage.features.customVocabulary.description', 'Train the AI on your industry-specific terms'),
      icon: '📚'
    },
    {
      title: t('featuresPage.features.secureStorage.title', 'Secure Storage'),
      description: t('featuresPage.features.secureStorage.description', 'Enterprise-grade encryption for all your data'),
      icon: '🔒'
    }
  ];

  return (
    <main className="container mx-auto px-4 py-16">
      <section className="text-center mb-16">
        <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">{t('featuresPage.title')}</h1>
        <p className="text-xl text-gray-500 dark:text-gray-400">
          {t('featuresPage.subtitle')}
        </p>
      </section>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {features.map((feature) => (
          <div
            key={feature.title}
            className="p-6 border border-gray-200 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors dark:border-gray-700 dark:bg-gray-900/50 dark:hover:bg-gray-800/50"
          >
            <div className="text-4xl mb-4">{feature.icon}</div>
            <h2 className="text-xl font-bold mb-2 text-gray-900 dark:text-white">{feature.title}</h2>
            <p className="text-gray-500 dark:text-gray-400">{feature.description}</p>
          </div>
        ))}
      </div>

      <section className="mt-16 text-center">
        <h2 className="text-3xl font-bold mb-8 text-gray-900 dark:text-white">{t('featuresPage.readyTitle')}</h2>
        <a 
          href={getStoreUrl(i18n.language)}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 inline-block"
        >
          {t('featuresPage.downloadNow')}
        </a>
      </section>
    </main>
  );
};

export default FeaturesPage;